import React from 'react'
import Layout from '../elements/Layout'

const Accounting = () => {
  return (
    <Layout>Accounting</Layout>
  )
}

export default Accounting